<div class="lds-ellipsis">
  <app-dot [color]="'supporting-5-light-blue'" class="dot"></app-dot>
  <app-dot [color]="'primary-bg-blue-grey'" class="dot"></app-dot>
  <app-dot [color]="'supporting-13-green'" class="dot"></app-dot>
  <app-dot [color]="'supporting-5-light-blue'" class="dot"></app-dot>
</div>
